export default function Benefits() {

  const items = [
    {icon: 'images/volume.svg', label: 'Volume', title: 'Hundred Logs'},
    {icon: 'images/precision.svg',label: 'Precision', title: '98% Accuracy'}
  ];


  return (
    <section id="benefits" className="block block-benefits">
      <div className="container">
        <div className="row g-4">
        {items.map((item, index) => (
          <div className="card col-6 mb-3" key={index}>
            <div className="row g-0">
              <div className="col img d-flex align-items-center justify-content-center">
                <img src={item.icon} className="icon" alt={item.label}/>
              </div>
              <div className="col">
                <div className="card-body">
                  <span className="card-label">{item.label}</span>
                  <h5 className="card-title">{item.title}</h5>
                </div>
              </div>
            </div>
          </div>
        ))}
        </div>

      </div>
    </section>
  );
}
